import { TypeOrNull } from 'models/Common'
import { IError } from 'models/Global'
import { IRoster } from 'models/Roster'
import { SHIFT_STATUS } from 'models/Shift'
import { TShiftEditValues } from '@features/shift-post-v2/pages/edit-shift/edit-shift.types'
import { IPostShiftFormValues } from '@features/shift-post-v2/pages/post-shift/post-shift.form'
import { ACCEPTANCE_CRITERIA_OPTION, ShiftPostStep } from '../steps'

export interface IExtendedRoster extends IRoster {
  selectedForInvite?: boolean
}

export interface IShiftDetailsStepData {
  // Add fields based on what shift details needs
}

export interface IAcceptanceCriteriaStepData {
  // Add fields based on what acceptance criteria needs
  selectedOption: ACCEPTANCE_CRITERIA_OPTION
  selectedRosters: IExtendedRoster[]
}

export interface IScreeningRequirementsStepData {
  // Add fields based on what screening requirements needs
}

export interface IInviteUpshiftersStepData {
  // Add fields based on what invite upshifters needs
}

export interface IConfirmStepData {
  // Add fields based on what confirm step needs
}

// Step state interface
export interface IStepState<T> {
  data: T
  confirmed: boolean
}

// Overall state interface
export interface IShiftPostV2State {
  steps: {
    [ShiftPostStep.SHIFT_DETAILS]: IStepState<IShiftDetailsStepData>
    [ShiftPostStep.ACCEPTANCE_CRITERIA]: IStepState<IAcceptanceCriteriaStepData>
    [ShiftPostStep.SCREENING_REQUIREMENTS]: IStepState<IScreeningRequirementsStepData>
    [ShiftPostStep.INVITE_UPSHIFTERS]: IStepState<IInviteUpshiftersStepData>
    [ShiftPostStep.CONFIRM]: IStepState<IConfirmStepData>
  }
  isLoading: boolean
  error: TypeOrNull<string>
  initialValues: TypeOrNull<IPostShiftFormValues>
  copyEditInitialValues: TypeOrNull<TShiftEditValues | IPostShiftFormValues>
  copyEditStatusForRequest: TypeOrNull<SHIFT_STATUS>
  rosterData: {
    isFetching: boolean
    error: TypeOrNull<IError>
    data: IExtendedRoster[]
  }
}

export interface IConfirmStepPayload {
  step: ShiftPostStep
}

export enum STEP_INDEX {
  SHIFT_DETAILS = 0,
  ACCEPTANCE_CRITERIA = 1,
  SCREENING_REQUIREMENTS = 2,
  INVITE_UPSHIFTERS = 3,
  CONFIRM = 4,
}
